import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ICostBuilding } from './types'
import { CostBuildingFragment } from './fragments'

interface Props {
  city: string
  year: number
}

interface IPayload {
  data: {
    viewer: {
      company: IBuildingPayload
    }
  }
}

interface IBuildingPayload {
  buildings: ICostBuilding[]
}

export default function byCity({ city, year }: Props): Promise<IBuildingPayload> {
  const variables: any = { year }
  if (city) variables.cities = [city]

  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: { buildings },
        },
      },
    }: IPayload) => {
      return { buildings }
    }
  )
}

export const query = gql`
  query costByCity($cities: [String], $year: Int!) {
    viewer {
      company {
        buildings(cities: $cities, includeOldBuildings: true) {
          ...CostBuildingFragment
        }
      }
    }
  }
  ${CostBuildingFragment}
`
